import i18next from "i18next"
import { buildValidator, isValidatorPassed, Validator, validatorBuilders, ValidatorResult, validatorResultBuilders } from "../../validator/validator"
import { Updater } from "widgets-for-react"

export type ChangePassword = Partial<{
  current:string
  new:string
  repeated:string
}>

export const emptyChangePassword : ChangePassword = {}

const changePasswordValidator = buildValidator<ChangePassword>({
  current:[b => b.notEmpty(), validatorBuilders.string("current", () => i18next.t(`subscriptionValidators:CurrentPassword`))],
  new:[b => b.matches(/^.{8,}$/), validatorBuilders.string("new", () => i18next.t(`subscriptionValidators:NewPassword`))],
  repeated:[b => b.fromPromise(async(state,value) => 
    state.repeated == undefined ? undefined
    : state.repeated == state.new), validatorBuilders.string("repeated", () => i18next.t(`subscriptionValidators:RepeatedPassword`))],
})

export type ChangePasswordState = {
  input:ChangePassword
  validator:Validator<ChangePassword, ChangePassword>,
  validatorResult:ValidatorResult
  isValid():boolean,
}

export const initialChangePasswordState : ChangePasswordState = ({
  input:emptyChangePassword,
  validator:changePasswordValidator.setValueToValidate(emptyChangePassword,emptyChangePassword),
  validatorResult:validatorResultBuilders.validating(""),
  isValid:function(this:ChangePasswordState) { return isValidatorPassed(this.validatorResult) }
})

// export const fieldUpdater = <s>() => <k extends keyof s>(k:k) => 
//   (u:Updater<s[k]>) : Updater<s> => s => ({...s, [k]:u(s[k])})

export const changePasswordStateUpdaters = {
  input:(u:Updater<ChangePasswordState["input"]>) : Updater<ChangePasswordState> =>
    s => {
      const newInput = u(s.input)
      return ({...s, input:newInput, validator:s.validator.setValueToValidate(newInput, newInput)})
    },
  validation:(u:Updater<ChangePasswordState["validator"]>) : Updater<ChangePasswordState> =>
    s => {
      const newValidator = u(s.validator)
      return ({...s, validator:newValidator, validatorResult:newValidator.evaluateResult() })
    },  
}

export const changePasswordUpdaters = {
  current:(u:Updater<ChangePassword["current"]>) : Updater<ChangePassword> =>
    s => ({...s, current:u(s.current)}),
  new:(u:Updater<ChangePassword["new"]>) : Updater<ChangePassword> =>
    s => ({...s, new:u(s.new)}),
  repeated:(u:Updater<ChangePassword["repeated"]>) : Updater<ChangePassword> =>
    s => ({...s, repeated:u(s.repeated)}),
}
